import { useTranslation } from "react-i18next";
import { Params, UIMatch, useMatches } from "react-router";

import { NavigationMenuLinks } from "@/components/NavigationMenu";
import { TDynamicCategory } from "@/types";

export type CustomUIMatch = UIMatch<
  unknown,
  {
    breadcrumb?: (
      params: Params,
      categories?: TDynamicCategory[],
      trackingCampaignScoreId?: string
    ) => {
      href: string;
      label: string;
    }[];
    isOverlayed?: boolean;
    activeMenuLink?: (
      params: Params,
      trackingCampaignScoreId?: string
    ) => NavigationMenuLinks;
  }
>;

const useBreadcrumbs = (categories?: TDynamicCategory[]) => {
  const { t } = useTranslation([
    "navigation-menu",
    "reviewCategories",
    "options", // if the crumb text is not translated, check that you have put the namespace here
  ]);
  const matches = useMatches() as CustomUIMatch[];

  const trackingCampaignScoreId = localStorage.getItem("currentScoreId");

  const crumbs = matches
    // first get rid of any matches that don't have handle and breadcrumb
    .filter((match) => Boolean(match.handle?.breadcrumb))
    // now map them into an array of elements, passing the params to each one
    .map((match) =>
      match.handle.breadcrumb!(
        match.params,
        categories,
        trackingCampaignScoreId || undefined
      )
    )
    .filter(Boolean) // remove any null or empty array needed for routes that retunr no breadcrumb
    .flat(); // flatten the array of arrays (needed for routes that return multiple breadcrumbs)

  // replace the labels in crumbs with the translated ones
  crumbs.forEach((crumb) => {
    crumb.label = t(crumb.label);
  });

  const isOverlayed = matches[matches.length - 1]?.handle?.isOverlayed;

  return { crumbs, isOverlayed };
};

export default useBreadcrumbs;
